import { useParams, Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import PageLoading from '@/components/layout/PageLoading';
import { Button } from '@/components/ui/button';

import CollapsibleCartItems from './CollapsibleCartItems';

import { useCart } from '@/data/cart';

const CartViewPage = () => {
  const params = useParams();
  const cartId = params.id;

  const cart = useCart(cartId);

  if (cart.isLoading && !cart.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Cart</CardTitle>
        </CardHeader>
        <CardContent>
          <CollapsibleCartItems cartId={cartId} />
          <Link to={`/checkout/cart/${cartId}/step/customer`}>
            <Button className="w-full mt-4">
              <CreditCard className="w-6 h-6 mr-2" />
              Checkout
            </Button>
          </Link>
        </CardContent>
      </Card>
      <div className="p-8"></div>
    </Page>
  );
};

export default CartViewPage;
